import { useFeedback } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Dropdown, Tag, Tooltip, Typography } from "antd";
import { MenuItemType } from "antd/es/menu/interface";
import { observer } from "mobx-react-lite";
import React from "react";
import { PriorityIcon, saveTicket, useTicketData } from "../..";
import { getPriorityProps } from "../functions/getPriorityProps";

type Props = {
  asIcon?: boolean;
  onSave?: Function;
};

export const PriorityTag = observer((props: Props) => {
  const t = useTranslation();
  const ticketData = useTicketData();
  const { handleLoadingFeedback } = useFeedback();
  const {
    thresholds,
    getPriorityLabelByValue,
    getPriorityTagColor,
    getPriorityThresholdByValue,
  } = getPriorityProps();

  const threshold = getPriorityThresholdByValue(
    ticketData.priority?.get("value")
  );
  const label = t(getPriorityLabelByValue(threshold));
  const color = getPriorityTagColor(threshold);

  const items: MenuItemType[] = thresholds
    .filter((t) => t !== threshold)
    .map((threshold) => ({
      key: threshold.toString(),
      label: t(getPriorityLabelByValue(threshold)),
    }));

  const priorityDisplay = props.asIcon ? (
    <Tooltip title={label}>
      <PriorityIcon
        value={ticketData.priority?.get("value")}
        style={{
          cursor: "pointer",
        }}
      />
    </Tooltip>
  ) : (
    <Tag color={color}>
      <Typography.Text
        style={{
          color: ticketData.priority?.get("value") > 75 ? "#FFF" : "#222",
        }}
      >
        {label} ({ticketData.priority?.get("value")})
      </Typography.Text>
    </Tag>
  );

  async function updatePriority(value: string) {
    const prio = Number(value);
    const result = await handleLoadingFeedback(
      () =>
        saveTicket({ existingTicketId: ticketData.ticket.id, priority: prio }),
      t("maintenance:ticket.priority.loading"),
      t("maintenance:ticket.priority.success"),
      t("maintenance:ticket.priority.error")
    );
    result && props.onSave?.();
  }

  return (
    <Dropdown
      menu={{ items, onClick: (info) => updatePriority(info.key) }}
      trigger={["click"]}
      placement="bottom"
      arrow={{ pointAtCenter: true }}
    >
      <div>{priorityDisplay}</div>
    </Dropdown>
  );
});
